import { Outlet, useNavigation } from "react-router";
import { Toaster } from "~/components/ui/sonner";
import Navbar from "./Navbar";
import Footer from "./Footer";
import DemoBanner from "./DemoBanner";

export default function Layout() {
  const navigation = useNavigation();
  const isLoading = navigation.state === "loading";

  return (
    <div className="min-h-[100dvh] flex flex-col bg-bg-primary">
      <DemoBanner />
      <Navbar />
      {/* Global navigation loading indicator */}
      {isLoading && (
        <div className="fixed top-0 left-0 right-0 h-1 z-[200] bg-accent-cyan/20">
          <div className="h-full bg-accent-cyan animate-pulse" />
        </div>
      )}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}
